export default __webpack_public_path__ + "static/media/ic-login.397b50cb.svg";